import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';

import PageAnnouncement from './pages/PageAnnouncement.jsx';
import PageAnnouncements from './pages/PageAnnouncements.jsx';

const App = () => (
    <Router>
        <div className="w-100">
          <Switch>
            <Route exact path="/announcements">
              <PageAnnouncements appPath='' />
            </Route>
            <Route exact path="/announcements/:_id">
              <PageAnnouncement />
            </Route>
          </Switch>
        </div>
    </Router>
);

export default App;
